export const defaultAttributesFn = (p) => ({});
export const createExtender = function createExtender(defaults, 
/** We're defaulting to an Object.create call here to circumvent
 *  the fact that {} can't be reconciled
 *  with a type that extends Record<string, any>
 *
 *  By doing this, we are intentionally disallowing users
 *  from nullifying a particular component in the tree.
 *  This can be reverted with additional logic,
 *  at such a time as this nullification becomes an actual usecase.
 * */
overrides = Object.create(Object.prototype)) {
    if (!defaults) {
        throw new Error('a default set of overrides *must* be passed in as the first argument');
    }
    return function getOverrides(key) {
        const { cssFn: defaultCssFn, attributesFn: defaultAttributesFn, component: defaultComponent, } = defaults[key];
        if (!overrides[key]) {
            return {
                cssFn: defaultCssFn,
                attributesFn: defaultAttributesFn,
                component: defaultComponent,
            };
        }
        const { cssFn: customCssFn, attributesFn: customAttributesFn, component: customComponent, } = overrides[key];
        const composedCssFn = (state) => {
            return customCssFn(defaultCssFn(state), state);
        };
        return {
            cssFn: customCssFn ? composedCssFn : defaultCssFn,
            attributesFn: customAttributesFn || defaultAttributesFn,
            component: customComponent || defaultComponent,
        };
    };
};
//# sourceMappingURL=utils.js.map